import { TicketCancelReasonFormType } from 'components/ticket-cancel-reasons/TicketCancelReasonForm';

export const createTicketCancelReasonInitialValues: Partial<TicketCancelReasonFormType> = {
  isActive: true
};
